import { render, staticRenderFns } from "./AdminFacilityProfileForm.vue?vue&type=template&id=6e362d1f"
import script from "./AdminFacilityProfileForm.vue?vue&type=script&lang=ts"
export * from "./AdminFacilityProfileForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports